/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(<any>null);
    }
}

export class InsightsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTaskReport(guid: string | null): Promise<CronTaskReport> {
        let url_ = this.baseUrl + "/Insights/{guid}/state";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskReport(_response);
        });
    }

    protected processGetTaskReport(response: Response): Promise<CronTaskReport> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CronTaskReport.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CronTaskReport>(<any>null);
    }
}

export class TasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    startTask(taskRunRequest: TaskRunRequest): Promise<TaskRunResponse> {
        let url_ = this.baseUrl + "/Tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskRunRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartTask(_response);
        });
    }

    protected processStartTask(response: Response): Promise<TaskRunResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskRunResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskRunResponse>(<any>null);
    }

    getTaskState(guid: string | null): Promise<CronTaskState> {
        let url_ = this.baseUrl + "/Tasks/{guid}/state";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskState(_response);
        });
    }

    protected processGetTaskState(response: Response): Promise<CronTaskState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CronTaskState.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CronTaskState>(<any>null);
    }

    getLatestTasks(count: number): Promise<CronTask[]> {
        let url_ = this.baseUrl + "/Tasks/latest/{count}";
        if (count === undefined || count === null)
            throw new Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestTasks(_response);
        });
    }

    protected processGetLatestTasks(response: Response): Promise<CronTask[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CronTask.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CronTask[]>(<any>null);
    }

    searchTasks(taskModule: string | null | undefined, taskName: string | null | undefined, taskTimeSortOrder: SortOrder | null | undefined, startTimeUnixMilli: number | null | undefined, endTimeUnixMilli: number | null | undefined, limit: number | null | undefined): Promise<CronTask[]> {
        let url_ = this.baseUrl + "/Tasks/search?";
        if (taskModule !== undefined && taskModule !== null)
            url_ += "taskModule=" + encodeURIComponent("" + taskModule) + "&";
        if (taskName !== undefined && taskName !== null)
            url_ += "taskName=" + encodeURIComponent("" + taskName) + "&";
        if (taskTimeSortOrder !== undefined && taskTimeSortOrder !== null)
            url_ += "taskTimeSortOrder=" + encodeURIComponent("" + taskTimeSortOrder) + "&";
        if (startTimeUnixMilli !== undefined && startTimeUnixMilli !== null)
            url_ += "startTimeUnixMilli=" + encodeURIComponent("" + startTimeUnixMilli) + "&";
        if (endTimeUnixMilli !== undefined && endTimeUnixMilli !== null)
            url_ += "endTimeUnixMilli=" + encodeURIComponent("" + endTimeUnixMilli) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchTasks(_response);
        });
    }

    protected processSearchTasks(response: Response): Promise<CronTask[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CronTask.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CronTask[]>(<any>null);
    }

    getTaskEvents(guid: string | null): Promise<CronTaskEvent[]> {
        let url_ = this.baseUrl + "/Tasks/{guid}/events";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskEvents(_response);
        });
    }

    protected processGetTaskEvents(response: Response): Promise<CronTaskEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CronTaskEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CronTaskEvent[]>(<any>null);
    }

    getResultsDownloadUrl(guid: string | null, filenameOverride: string | null | undefined): Promise<TaskResultDownload> {
        let url_ = this.baseUrl + "/Tasks/{guid}/results?";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        if (filenameOverride !== undefined && filenameOverride !== null)
            url_ += "filenameOverride=" + encodeURIComponent("" + filenameOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetResultsDownloadUrl(_response);
        });
    }

    protected processGetResultsDownloadUrl(response: Response): Promise<TaskResultDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResultDownload.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskResultDownload>(<any>null);
    }

    getStoredObjDownloadUrl(taskGuid: string | null, storageGuid: string | null, objectPrefix: string | null | undefined, filenameOverride: string | null | undefined): Promise<TaskStoredObjDownload> {
        let url_ = this.baseUrl + "/Tasks/{taskGuid}/storage/{storageGuid}?";
        if (taskGuid === undefined || taskGuid === null)
            throw new Error("The parameter 'taskGuid' must be defined.");
        url_ = url_.replace("{taskGuid}", encodeURIComponent("" + taskGuid));
        if (storageGuid === undefined || storageGuid === null)
            throw new Error("The parameter 'storageGuid' must be defined.");
        url_ = url_.replace("{storageGuid}", encodeURIComponent("" + storageGuid));
        if (objectPrefix !== undefined && objectPrefix !== null)
            url_ += "objectPrefix=" + encodeURIComponent("" + objectPrefix) + "&";
        if (filenameOverride !== undefined && filenameOverride !== null)
            url_ += "filenameOverride=" + encodeURIComponent("" + filenameOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStoredObjDownloadUrl(_response);
        });
    }

    protected processGetStoredObjDownloadUrl(response: Response): Promise<TaskStoredObjDownload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskStoredObjDownload.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskStoredObjDownload>(<any>null);
    }

    getTaskSpec(guid: string | null): Promise<TaskSpec> {
        let url_ = this.baseUrl + "/Tasks/{guid}/taskspec";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskSpec(_response);
        });
    }

    protected processGetTaskSpec(response: Response): Promise<TaskSpec> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSpec.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskSpec>(<any>null);
    }
}

export class HealthStatus implements IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.buildEnvironment = _data["buildEnvironment"];
            this.database = _data["database"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["buildEnvironment"] = this.buildEnvironment;
        data["database"] = this.database;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;
}

export class CronTaskReport implements ICronTaskReport {
    cronTaskStateTid!: number;
    cronTaskTid!: number;
    guid!: string;
    cronTaskStateType!: CronTaskStateType;
    eventDatetime!: Date;
    userLogs!: UserLogEvent[];

    constructor(data?: ICronTaskReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userLogs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronTaskStateTid = _data["cronTaskStateTid"];
            this.cronTaskTid = _data["cronTaskTid"];
            this.guid = _data["guid"];
            this.cronTaskStateType = _data["cronTaskStateType"];
            this.eventDatetime = _data["eventDatetime"] ? new Date(_data["eventDatetime"].toString()) : <any>undefined;
            if (Array.isArray(_data["userLogs"])) {
                this.userLogs = [] as any;
                for (let item of _data["userLogs"])
                    this.userLogs!.push(UserLogEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CronTaskReport {
        data = typeof data === 'object' ? data : {};
        let result = new CronTaskReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronTaskStateTid"] = this.cronTaskStateTid;
        data["cronTaskTid"] = this.cronTaskTid;
        data["guid"] = this.guid;
        data["cronTaskStateType"] = this.cronTaskStateType;
        data["eventDatetime"] = this.eventDatetime ? this.eventDatetime.toISOString() : <any>undefined;
        if (Array.isArray(this.userLogs)) {
            data["userLogs"] = [];
            for (let item of this.userLogs)
                data["userLogs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICronTaskReport {
    cronTaskStateTid: number;
    cronTaskTid: number;
    guid: string;
    cronTaskStateType: CronTaskStateType;
    eventDatetime: Date;
    userLogs: UserLogEvent[];
}

export enum CronTaskStateType {
    Provisioning = 0,
    Running = 1,
    Success = 2,
    Failure = 3,
}

export class UserLogEvent implements IUserLogEvent {
    eventDatetime!: Date;
    eventMessage!: string;

    constructor(data?: IUserLogEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDatetime = _data["eventDatetime"] ? new Date(_data["eventDatetime"].toString()) : <any>undefined;
            this.eventMessage = _data["eventMessage"];
        }
    }

    static fromJS(data: any): UserLogEvent {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDatetime"] = this.eventDatetime ? this.eventDatetime.toISOString() : <any>undefined;
        data["eventMessage"] = this.eventMessage;
        return data;
    }
}

export interface IUserLogEvent {
    eventDatetime: Date;
    eventMessage: string;
}

export class TaskRunResponse implements ITaskRunResponse {
    guid!: string;

    constructor(data?: ITaskRunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): TaskRunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface ITaskRunResponse {
    guid: string;
}

export class TaskRunRequest implements ITaskRunRequest {
    taskModule!: string;
    taskName!: string;
    killTimeoutSeconds?: number | undefined;
    specs?: { [key: string]: any; } | undefined;

    constructor(data?: ITaskRunRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskModule = _data["taskModule"];
            this.taskName = _data["taskName"];
            this.killTimeoutSeconds = _data["killTimeoutSeconds"];
            if (_data["specs"]) {
                this.specs = {} as any;
                for (let key in _data["specs"]) {
                    if (_data["specs"].hasOwnProperty(key))
                        (<any>this.specs)![key] = _data["specs"][key];
                }
            }
        }
    }

    static fromJS(data: any): TaskRunRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRunRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskModule"] = this.taskModule;
        data["taskName"] = this.taskName;
        data["killTimeoutSeconds"] = this.killTimeoutSeconds;
        if (this.specs) {
            data["specs"] = {};
            for (let key in this.specs) {
                if (this.specs.hasOwnProperty(key))
                    (<any>data["specs"])[key] = this.specs[key];
            }
        }
        return data;
    }
}

export interface ITaskRunRequest {
    taskModule: string;
    taskName: string;
    killTimeoutSeconds?: number | undefined;
    specs?: { [key: string]: any; } | undefined;
}

export class CronTaskState implements ICronTaskState {
    cronTaskStateTid!: number;
    cronTaskTid!: number;
    guid!: string;
    cronTaskStateType!: CronTaskStateType;
    eventDatetime!: Date;

    constructor(data?: ICronTaskState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronTaskStateTid = _data["cronTaskStateTid"];
            this.cronTaskTid = _data["cronTaskTid"];
            this.guid = _data["guid"];
            this.cronTaskStateType = _data["cronTaskStateType"];
            this.eventDatetime = _data["eventDatetime"] ? new Date(_data["eventDatetime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CronTaskState {
        data = typeof data === 'object' ? data : {};
        let result = new CronTaskState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronTaskStateTid"] = this.cronTaskStateTid;
        data["cronTaskTid"] = this.cronTaskTid;
        data["guid"] = this.guid;
        data["cronTaskStateType"] = this.cronTaskStateType;
        data["eventDatetime"] = this.eventDatetime ? this.eventDatetime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICronTaskState {
    cronTaskStateTid: number;
    cronTaskTid: number;
    guid: string;
    cronTaskStateType: CronTaskStateType;
    eventDatetime: Date;
}

export class CronTask implements ICronTask {
    cronTaskTid!: number;
    guid!: string;
    taskModule!: string | undefined;
    taskName!: string | undefined;

    constructor(data?: ICronTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronTaskTid = _data["cronTaskTid"];
            this.guid = _data["guid"];
            this.taskModule = _data["taskModule"];
            this.taskName = _data["taskName"];
        }
    }

    static fromJS(data: any): CronTask {
        data = typeof data === 'object' ? data : {};
        let result = new CronTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronTaskTid"] = this.cronTaskTid;
        data["guid"] = this.guid;
        data["taskModule"] = this.taskModule;
        data["taskName"] = this.taskName;
        return data;
    }
}

export interface ICronTask {
    cronTaskTid: number;
    guid: string;
    taskModule: string | undefined;
    taskName: string | undefined;
}

export enum SortOrder {
    Ascending = 0,
    Descending = 1,
    Unspecified = -1,
}

export class CronTaskEvent implements ICronTaskEvent {
    cronTaskEventTid!: number;
    cronTaskTid!: number;
    cronTaskEventType!: CronTaskEventType;
    eventDatetime!: Date;
    eventMessage!: string;

    constructor(data?: ICronTaskEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cronTaskEventTid = _data["cronTaskEventTid"];
            this.cronTaskTid = _data["cronTaskTid"];
            this.cronTaskEventType = _data["cronTaskEventType"];
            this.eventDatetime = _data["eventDatetime"] ? new Date(_data["eventDatetime"].toString()) : <any>undefined;
            this.eventMessage = _data["eventMessage"];
        }
    }

    static fromJS(data: any): CronTaskEvent {
        data = typeof data === 'object' ? data : {};
        let result = new CronTaskEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cronTaskEventTid"] = this.cronTaskEventTid;
        data["cronTaskTid"] = this.cronTaskTid;
        data["cronTaskEventType"] = this.cronTaskEventType;
        data["eventDatetime"] = this.eventDatetime ? this.eventDatetime.toISOString() : <any>undefined;
        data["eventMessage"] = this.eventMessage;
        return data;
    }
}

export interface ICronTaskEvent {
    cronTaskEventTid: number;
    cronTaskTid: number;
    cronTaskEventType: CronTaskEventType;
    eventDatetime: Date;
    eventMessage: string;
}

export enum CronTaskEventType {
    Received = 0,
    Dispatched = 1,
    Started = 2,
    Completed = 3,
    Pong = 4,
    Dead = 5,
    Log = 6,
    Error = 7,
    ApiSubmitted = 8,
    SubtaskSubmitted = 9,
    ResultsUploaded = 10,
    ObjectUploaded = 11,
    UserLog = 12,
}

export class TaskResultDownload implements ITaskResultDownload {
    guid!: string;
    presignedUrl!: string | undefined;

    constructor(data?: ITaskResultDownload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.presignedUrl = _data["presignedUrl"];
        }
    }

    static fromJS(data: any): TaskResultDownload {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResultDownload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["presignedUrl"] = this.presignedUrl;
        return data;
    }
}

export interface ITaskResultDownload {
    guid: string;
    presignedUrl: string | undefined;
}

export class TaskStoredObjDownload implements ITaskStoredObjDownload {
    objectPrefix!: string | undefined;
    objectGuid!: string;
    presignedUrl!: string | undefined;

    constructor(data?: ITaskStoredObjDownload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectPrefix = _data["objectPrefix"];
            this.objectGuid = _data["objectGuid"];
            this.presignedUrl = _data["presignedUrl"];
        }
    }

    static fromJS(data: any): TaskStoredObjDownload {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStoredObjDownload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectPrefix"] = this.objectPrefix;
        data["objectGuid"] = this.objectGuid;
        data["presignedUrl"] = this.presignedUrl;
        return data;
    }
}

export interface ITaskStoredObjDownload {
    objectPrefix: string | undefined;
    objectGuid: string;
    presignedUrl: string | undefined;
}

export class TaskSpec implements ITaskSpec {
    scheduleId?: string | undefined;
    taskModule!: string;
    taskName!: string;
    guid!: string;
    killTimeoutSeconds?: number | undefined;
    specs?: { [key: string]: any; } | undefined;

    constructor(data?: ITaskSpec) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.taskModule = _data["taskModule"];
            this.taskName = _data["taskName"];
            this.guid = _data["guid"];
            this.killTimeoutSeconds = _data["killTimeoutSeconds"];
            if (_data["specs"]) {
                this.specs = {} as any;
                for (let key in _data["specs"]) {
                    if (_data["specs"].hasOwnProperty(key))
                        (<any>this.specs)![key] = _data["specs"][key];
                }
            }
        }
    }

    static fromJS(data: any): TaskSpec {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSpec();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["taskModule"] = this.taskModule;
        data["taskName"] = this.taskName;
        data["guid"] = this.guid;
        data["killTimeoutSeconds"] = this.killTimeoutSeconds;
        if (this.specs) {
            data["specs"] = {};
            for (let key in this.specs) {
                if (this.specs.hasOwnProperty(key))
                    (<any>data["specs"])[key] = this.specs[key];
            }
        }
        return data;
    }
}

export interface ITaskSpec {
    scheduleId?: string | undefined;
    taskModule: string;
    taskName: string;
    guid: string;
    killTimeoutSeconds?: number | undefined;
    specs?: { [key: string]: any; } | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}